// material-ui
import { styled } from '@mui/material/styles';


// ==============================|| AUTHENTICATION 1 WRAPPER ||============================== //

const AuthWrapper1 = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.primary.dark,
    minHeight: '100vh'
}));

export default AuthWrapper1;
